import { useState } from "react";
import Modal from "./modal";
import DepsUnits from "../depsUnits";

const DepsUnitsSummary = (props) => {
  const [showModal, setShowModal] = useState(false);
  const edit = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
  };
  const save = (event) => {
    event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
  };
  return (
    <div className="card  h-100">
      {showModal && (
        <Modal label={"Departments"} showHide={edit} saveFunction={save}>
          <DepsUnits errors={props.errors}  />
        </Modal>
      )}
      <div className="card-header">
        <b>
          <h5 className="mb-0">Departments</h5>
        </b>
        {props.editMode && (
          <a
            className="edit-icon"
            id="btnShowModel_Job_Type"
            href="#"
            onClick={edit}
          >
            <i className="fe fe-edit" title="Edit Template"></i>
          </a>
        )}
      </div>
      <div className="card-body">
        <div className="form-group">
          <>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                {/* <label className="form-label">
                  Departments
                </label> */}
                {/* {props?.depsUnits?.map((deps) => ( */}
                  <div>
                    <label>{props?.depsUnits?.name}</label>
                  </div>
                {/* ))} */}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default DepsUnitsSummary;
